export default "__VITE_ASSET__dewxhPQg__"